import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import ProtectedRoute from './auth/ProtectedRoute';
import MainLayout from './layout/MainLayout';
import { useAuth } from './auth/AuthContext';
import PersonnelPage from './pages/Personnel/PersonnelPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import CashPage from './pages/Cash/CashPage';
import LoginPage from './pages/Login/LoginPage';
import RegisterPage from './pages/Login/RegisterPage';
import ForgotPasswordPage from './pages/Login/ForgotPasswordPage';
import ResetPasswordPage from './pages/Login/ResetPasswordPage';
import MachinesHomePage from "./pages/Machines/MachinesHomePage";
import VendorMachinesPage from "./pages/Machines/VendorMachinesPage";
import MachineDetailPage from "./pages/Machines/MachineDetailPage";
import { VendorOverviewPage } from "./pages/VendorOverviewPage";
import IrinoxAnalyticsPage from "./pages/irinox/IrinoxAnalyticsPage";
import IfiGalileoAnalyticsPage from "./pages/ifi-galileo/IfiGalileoAnalyticsPage";
import RationalAnalyticsPage from "./pages/rational/RationalAnalyticsPage";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in Route
import KitchenAnalyticsPage from "./pages/Dashboard/KitchenAnalyticsPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import MaintenancePage from "./pages/Maintenance/MaintenancePage";
import ArubaConfigPage from "./pages/Invoicing/ArubaConfigPage";
import InvoicesPage from "./pages/Invoicing/InvoicesPage";
import ReceivedInvoicesPage from "./pages/Invoicing/ReceivedInvoicesPage";
import InvoiceNotificationsPage from "./pages/Invoicing/InvoiceNotificationsPage";
import InvoiceSyncLogsPage from "./pages/Invoicing/InvoiceSyncLogsPage";
import ElectronicInvoicingArubaPage from "./pages/settings/ElectronicInvoicingArubaPage";
import InvoicesListPage from "./pages/invoices/InvoicesListPage";
import InvoiceDetailPage from "./pages/invoices/InvoiceDetailPage";
import ReceivedInvoicesListPage from "./pages/received-invoices/ReceivedInvoicesListPage";
import ReceivedInvoiceDetailPage from "./pages/received-invoices/ReceivedInvoiceDetailPage";
import PosMonitorPage from "./pages/Pos/PosMonitorPage";
import PosCatalogPage from "./pages/Pos/PosCatalogPage";
import PosProductsPage from "./pages/Pos/PosProductsPage";
import EasyRetailAnalysisPage from "./pages/Pos/EasyRetailAnalysisPage";
import VneAnalysisPage from "./pages/Pos/VneAnalysisPage";
import ScaleGatewayPage from "./pages/Pos/ScaleGatewayPage";
import ReportsHomePage from "./pages/Reports/ReportsHomePage";
import PosDownloadsPage from "./pages/Pos/PosDownloadsPage";
import EpsonRtPage from "./pages/Pos/EpsonRtPage";
import NotFoundPage from "./pages/NotFoundPage";



import './styles/layout.css';
import './styles/machines.css';
import './styles/personnel.css';
import './styles/maintenance.css';
import './styles/auth.css';

// Componente per gestire la route root "/"
function RedirectLegacyEasyRetailReport() {
  const { id } = useParams();
  return <Navigate to={id ? `/reports/easy-retail/${id}` : "/reports/easy-retail"} replace />;
}

function RootRoute() {
  const { isAuthenticated } = useAuth();
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <LoginPage />;
}

export default function App() {
  return (
    <Routes>
      {/* Route root: mostra login se non autenticato, reindirizza a dashboard se autenticato */}
      <Route path="/" element={<RootRoute />} />
      
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/cash" element={<CashPage />} />
          <Route path="/pos-monitor" element={<PosMonitorPage />} />
          <Route path="/pos/catalog" element={<PosCatalogPage />} />
          <Route path="/pos/products" element={<PosProductsPage />} />
          <Route path="/pos/epson-rt" element={<EpsonRtPage />} />
          <Route path="/reports" element={<ReportsHomePage />} />
          <Route path="/reports/easy-retail" element={<EasyRetailAnalysisPage />} />
          <Route path="/reports/easy-retail/:id" element={<EasyRetailAnalysisPage />} />
          <Route path="/reports/vne" element={<VneAnalysisPage />} />
          <Route path="/reports/vne/:id" element={<VneAnalysisPage />} />
          <Route path="/reports/scales" element={<ScaleGatewayPage />} />
          <Route path="/reports/scales/:id" element={<ScaleGatewayPage />} />
          <Route path="/reports/downloads" element={<PosDownloadsPage />} />
          <Route path="/pos/easy-retail" element={<RedirectLegacyEasyRetailReport />} />
          <Route path="/pos/easy-retail/:id" element={<RedirectLegacyEasyRetailReport />} />
          <Route path="/personnel" element={<PersonnelPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/machines" element={<MachinesHomePage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/invoices" element={<InvoicesListPage />} />
          <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
          <Route path="/received-invoices" element={<ReceivedInvoicesListPage />} />
          <Route path="/received-invoices/:id" element={<ReceivedInvoiceDetailPage />} />
          <Route path="/invoicing/invoices" element={<InvoicesPage />} />
          <Route path="/invoicing/received" element={<ReceivedInvoicesPage />} />
          <Route path="/invoicing/notifications" element={<InvoiceNotificationsPage />} />
          <Route path="/invoicing/aruba-config" element={<ArubaConfigPage />} />
          <Route path="/invoicing/sync-logs" element={<InvoiceSyncLogsPage />} />
          <Route path="/settings/electronic-invoicing/aruba" element={<ElectronicInvoicingArubaPage />} />
          <Route path="/machines/IRINOX/:machineId/analytics" element={<IrinoxAnalyticsPage />} />
          <Route path="/machines/IFI_GALILEO/:machineId/analytics" element={<IfiGalileoAnalyticsPage />} />
          <Route path="/machines/RATIONAL/analytics" element={<RationalAnalyticsPage />} />
          <Route path="/machines/RATIONAL/kitchen-analytics" element={<KitchenAnalyticsPage />} />
          <Route path="/machines/:provider" element={<VendorMachinesPage />} />
          <Route path="/machines/:provider/:machineId" element={<MachineDetailPage />} />
          <Route path="/overview" element={<VendorOverviewPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}